/*** IMPORTS FROM imports-loader ***/
var define = false;

/* global Foundation */

import $ from 'jquery';
import each from 'lodash/each';

/**
 * Set up tabs in the container.
 *
 * @param {HTMLElement} container
 */
function setupTabs(container) {
  if (!container) {
    return;
  }

  // Initialize existing elements:
  // No need. Foundation already does it.

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return;
        }

        const els = node.querySelectorAll('[data-tabs]');
        if (!els.length) {
          return;
        }

        each(els, (el) => {
          new Foundation.Tabs($(el));
        });
      });
    });
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });
}

// eslint-disable-next-line import/prefer-default-export
export { setupTabs };

